import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import FormTemplate from './Template'

const HeaderControl = (props) => {
  return <FormTemplate props={props} layout="header" />
}

export const headerControlTester = rankWith(3, scopeEndsWith('header'))

export default withJsonFormsControlProps(HeaderControl)
